import React from 'react';
import Header from 'on_web/components/shared/Menu/Header/Header';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import { Typography } from '@material-ui/core';

import Box from '@material-ui/core/Box';

import SectionTitle from 'on_web/components/shared/Common/SectionTitle';
import StepProgressIndicator from 'on_web/components/shared/StepProgressIndicator/StepProgressIndicator';
import PceStepProgressIndicator from 'on_web/components/shared/PceStepProgressIndicator/PceStepProgressIndicator';
import UserProfileContext from 'on_web/context/userProfileContext';

import { Trans, useTranslation } from 'react-i18next';

function DnaFileDownloadInstructions(props) {
  const context = React.useContext(UserProfileContext);

  const onClickNext = () => {
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata) {
      userMetadata.dnaDownloadInstructionsSeen = true;
      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();
  return (
    <div>
      <Header />
      {props.forPce && <PceStepProgressIndicator selectedSlideIx={0} />}

      <SectionTitle
        text={t(
          'onboarding.dnaSection.dnaFileDownloadInstructions.sectionTitle'
        )}
      />
      <Box
        p={{ xs: 2.5, sm: 3, md: 4 }}
        mr={{ xs: 2.5 }}
        justifyContent="center"
        display="flex"
      >
        <Typography variant="h5">
          {t('onboarding.dnaSection.dnaFileDownloadInstructions.heading1')}
        </Typography>
      </Box>

      <Box p={{ xs: 2.5, sm: 3, md: 4 }} mr={{ xs: 2.5 }}>
        <Typography variant="body1">
          <Trans i18nKey="onboarding.dnaSection.dnaFileDownloadInstructions.textBody1">
            0
            <a href="#" target="_blank" rel="noopener noreferrer">
              1
            </a>
            2
            <a href="#" target="_blank" rel="noopener noreferrer">
              3
            </a>
            4
          </Trans>
        </Typography>
      </Box>

      <Box
        p={{ xs: 2.5, sm: 3, md: 4 }}
        mr={{ xs: 2.5 }}
        justifyContent="center"
        display="flex"
      >
        <Typography variant="h5">
          {t('onboarding.dnaSection.dnaFileDownloadInstructions.heading2')}
        </Typography>
      </Box>

      <Box p={{ xs: 2.5, sm: 3, md: 4 }} mr={{ xs: 2.5 }}>
        <Typography variant="body1">
          {t('onboarding.dnaSection.dnaFileDownloadInstructions.textBody2')}
        </Typography>
      </Box>

      <StickyNavigation
        onClickNext={() => onClickNext()}
        onClickBack={() => onClickBack()}
      />
    </div>
  );
}

export default DnaFileDownloadInstructions;
